import {OnDestroy, OnInit} from '@angular/core';
import {Component} from '@angular/core';
import {RouterModule} from '@angular/router';
import {WaButtonDirective} from 'angular-awesome';
import {WaCardDirective} from 'angular-awesome';
import {WaTextDirective} from 'angular-awesome';
import {WaTagDirective} from 'angular-awesome';
import {WaDividerDirective} from 'angular-awesome';
import {WaDetailsDirective} from 'angular-awesome';
import {MarkdownComponent} from 'ngx-markdown';
@Component({
	selector:'jwebmp-plugin-fontawesome-pro',
	templateUrl:'./FontAwesomeProPluginPage.html',
	styles: [],
	styleUrls:['./FontAwesomeProPluginPage.scss'
],
	viewProviders:[],
	animations:[],
	providers:[],
	schemas:[],
	preserveWhitespaces:true,
	host:{},
	imports:[
		RouterModule,
		WaButtonDirective,
		WaCardDirective,
		WaTextDirective,
		WaTagDirective,
		WaDividerDirective,
		WaDetailsDirective,
		MarkdownComponent,
],
	standalone:true
})
export class FontAwesomeProPluginPage
{
	useGradle = false;
	private _storageListener: any;
	private _customListener: any;
	mdContent_576 = `\`\`\`xml
<dependency>
  <groupId>com.jwebmp.plugins</groupId>
  <artifactId>font-awesome-pro</artifactId>
</dependency>
\`\`\``;
	mdContent_577 = `\`\`\`kotlin
implementation("com.jwebmp.plugins:font-awesome-pro:2.0.0-SNAPSHOT")
\`\`\``;
	mdContent_578 = `\`\`\`json
"@fortawesome/pro-light-svg-icons": "^7.2.0"
"@fortawesome/pro-regular-svg-icons": "^7.2.0"
"@fortawesome/pro-solid-svg-icons": "^7.2.0"
"@fortawesome/pro-duotone-svg-icons": "^7.2.0"
"@fortawesome/pro-thin-svg-icons": "^7.2.0"
\`\`\``;
	mdContent_579 = `\`\`\`java
// Pro Regular icon
FontAwesome icon = IFontAwesome.createIcon(
    FontAwesomeIcons.user,
    FontAwesomeStyles.Regular);

// Pro Light icon
FontAwesome light = IFontAwesome.createIcon(
    FontAwesomeIcons.heart,
    FontAwesomeStyles.Light);

// Pro Duotone icon
FontAwesome duo = IFontAwesome.createIcon(
    FontAwesomeIcons.bell,
    FontAwesomeStyles.Duotone);
\`\`\``;
	mdContent_580 = `\`\`\`java
// Pro Regular icon
FontAwesome icon = IFontAwesome.createIcon(
    FontAwesomeIcons.user,
    FontAwesomeStyles.Regular);

// Pro Light icon
FontAwesome light = IFontAwesome.createIcon(
    FontAwesomeIcons.heart,
    FontAwesomeStyles.Light);

// Pro Duotone icon
FontAwesome duo = IFontAwesome.createIcon(
    FontAwesomeIcons.bell,
    FontAwesomeStyles.Duotone);
\`\`\``;
	ngOnInit() {
	    const saved = localStorage.getItem('jwebmp-build-tool');
	    if (saved) { this.useGradle = saved === 'gradle'; }
	    this._storageListener = (e: StorageEvent) => {
	        if (e.key === 'jwebmp-build-tool') {
	            this.useGradle = e.newValue === 'gradle';
	        }
	    };
	    this._customListener = (e: any) => {
	        this.useGradle = e.detail;
	    };
	    window.addEventListener('storage', this._storageListener);
	    window.addEventListener('jwebmp-build-tool-change', this._customListener);
	}
	ngOnDestroy() {
	    window.removeEventListener('storage', this._storageListener);
	    window.removeEventListener('jwebmp-build-tool-change', this._customListener);
	}

}
